<template>
    <el-row class="flex flex-ai-center flex-row">
        <div class="main-header-title" v-if="userInfo.user || userInfo.cookie">
            <slot name="title">
                <!-- logo -->
                <p></p>
                <!--<img src="../assets/icon_logo.png" alt="">-->
                <span class="header-tit" @click='$router.replace("/")' style='cursor:pointer'>ITSM管控平台</span>
            </slot>
        </div>
        <div class="flex1"></div>

        <!--消息小铃铛部分-->
        <noticeBell></noticeBell>
        <!--<div style="position: relative">小铃铛</div>-->

        <div class="cw flex-ai-center flex-jc-center" v-if="userInfo.user || userInfo.cookie">
            <user-info :shutDownTitle="closeTitleChange"></user-info>
        </div>
        <div class="user-info flex flex-center cw" v-else>
            <span @click="toLogin">登录</span>
            <span class="ml10" @click="toRegister">注册</span>
        </div>
    </el-row>
</template>

<script>

    import userInfo from './userInfo';
    import noticeBell from './noticeBell'
    import services from "../services/common.service";
    export default {
        data() {
            return {
                timer:null,
                time:0,
            }
        },
        components: {
            userInfo,
            noticeBell
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo || {};
            },
            username:function () {
                return this.userInfo.user.username
            }
        },
        mounted () {
            // if (this.userInfo.user === undefined && this.userInfo.cookie === undefined) {
            //     location.hash = '#/login'
            // }
            let vm = this;
            if (this.userInfo.user === undefined && this.userInfo.cookie === undefined) {
                location.hash = '#/login'
            }else{
                //有新消息显示提示
                // this.$interval(function () {
                //     vm.request();
                // },10000)
                // //设为多少分钟呢
            };
        },
        methods: {
            toLogin(){
                this.$router.replace('login');
            },
            toRegister() {
                this.$router.replace('login');
            },
            showMessage(){
                let vm = this;
                this.timer = setInterval(function () {
                    vm.time ++;
                    if(vm.time % 2){
                        document.title = "【有新消息】ITSM管控平台"
                    }else{
                        document.title = "【       】ITSM管控平台"
                    }
                },300)
            },
            closeTitleChange(){
                clearInterval(this.timer)
                this.timer = null;
                document.title = "ITSM管控平台"
            },
            request(){
                let params = {
                    hasNew:true,
                    user:this.username,
                    complete:"0",
                    pageIndex:1,
                    pageSize:10,
                };
                services.getMyAgencyList(params).then(res => {
                    if(res.hasNew){
                        // this.$message.info("有新消息,请查看");
                        this.$notify.info({
                            title:'新消息',
                            message:'您有新的待办',
                            position:'bottom-right',
                            duration:7500,
                            customClass:'noticeInform'
                        })
                        this.showMessage();
                    }
                    if (res.total===0){
                        clearInterval(this.timer)
                        this.timer = null;
                        document.title = "ITSM管控平台"
                    }

                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>
<style lang="scss" scoped rel="stylesheet/scss">
    body{
        .noticeInform{
            background: #a8e0ff;
            .el-notification__content{
                font-size: 16px;
            }
            .el-notification__closeBtn{
                color: white;
                font-size: 20px;
                &:hover{
                    color: black;
                }
            }
        }
    }
</style>
